import { clientRect } from 'chirashi'
import {css} from 'emotion'
import { upperCase } from 'lodash'
import {Colors, MenuLink} from './..'

const title = {
  fontSize: '2rem',
  fontWeight: 800,
  textAlign: 'center',
  textTransform: 'uppercase',
  position: 'relative',
  '&:after': {
    content: '""',
    display: 'block',
    width: 50,
    height: 4,
    margin: '1rem auto',
    background: 'black'
  }
}

export const PageStyle = (ready) => css({
  transition: 'all 400ms ease',
  opacity: ready ? 1 : 0,
  transform: `translateY(${ready ? 0 : 10 }px)`,
  '.page': {
    '&-title': {
      ...title,
    },
    '&-container': {
      margin: '2rem 0',
      'h2': {
        marginTop: '4rem',
      }
    }
  }
})

export const ContactStyle = (ready) => css({
  transition: `opacity 400ms ease`,
  // transform: `translateY(${ready ? 0 : 20}px)`,
  opacity: ready ? 1 : 0,
  '.contact': {
    '&-title': {
      ...title
    },
    '&-title-faq': {
      textTransform: 'uppercase',
      fontSize: '30px',
      lineHeight: '36px',
      margin: 0,
      textAlign: 'left',
      fontFamily: 'Interstate-Bold',
      marginBottom: '22px'
    },
    '&-form': {
      maxWidth: 800,
      margin: '0 auto',
      'input[type="text"], textarea': {
        margin: '0.5rem 0px'
      }
    },
    '&-btn-submit': {
      textAlign: 'right',
      'button': {
        maxWidth: 150
      }
    }
  },
  '.error': {
    textAlign: 'center'
  }
})

export const SitemapStyle = css({
  '.sitemap': {
    '&-row':{
      padding: '2rem 0',
      borderBottom: `1px solid ${Colors.extraLightGrey}`,
      '&:last-child': {
        borderBottom: 0
      },
      '@media (min-width: 1024px)': {
        padding: '4rem 0',
      }
    },
    '&-title': {
      maxWidth: '100%',
      flexBasis: '100%',
      textTransform: 'uppercase',
      fontWeight: 800,
      fontSize: '2rem',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(1/3 * 100%)',
        flexBasis: 'calc(1/3 * 100%)',
      }
    },
    '&-categories': {
      maxWidth: '100%',
      flexBasis: '100%',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(2/3 * 100%)',
        flexBasis: 'calc(2/3 * 100%)',
      }
    },
    '&-category': {
      maxWidth: '100%',
      flexBasis: '100%',
      marginTop: '1rem',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(1/3 * 100%)',
        flexBasis: 'calc(1/3 * 100%)',
        marginTop: 0,
      },

      '.category': {
        color: Colors.grey,
        fontSize: '1.5rem',
      },
    },
    '&-link': {
      margin: '1rem 0',
      'a': {
        fontSize: '0.9375rem',
        color: 'black',
        padding: '0.5rem 0',
      }
    }
  }
})

export const srOnlyStyle = css({
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  overflow: 'hidden',
  border: 0,
  clip: 'rect(0, 0, 0, 0)',
  pointerEvents: 'none'
})

export const PollStyle = css({
  position: 'absolute',
  top: '120px',
  left: '0',
  padding: '1rem 110px 2rem 1.75rem',
  maxWidth: 'calc(100% - 1rem)',
  border: '1px solid #000',
  borderLeft: 'none',
  zIndex: 3,
  backgroundColor: '#FFF',
  transition: '.4s ease-in-out transform',
  '@media (max-width: 767px)': {
    paddingRight: '3.75rem'
  },
  '&.is-closed': {
    transform: 'translateX(calc(-100% + 1rem))',

    '.poll__close svg': {
      transform: 'none'
    }
  },
  'fieldset': {
    border: 'none',
    padding: '0'
  },
  '.poll': {
    '&__close': {
      backgroundColor: '#D0021B',
      width: '1rem',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      border: 'none',
      cursor: 'pointer',

      'svg': {
        strokeWidth: '8px',
        stroke: '#000',
        marginLeft: '-6px',
        transform: 'scaleX(-1)'
      }
    },
    '&__free-wrap': {
      display: 'flex'
    },
    '&__free': {
      'label': {
        visibility: 'hidden',
        position: 'absolute'
      },
      'input': {
        border: 'none',
        marginLeft: '.5rem',
      }
    },
    '&__title': {
      margin: '0 0 1rem',
      fontWeight: 'bold',
      borderBottom: '6px solid #000',
      textTransform: 'uppercase',
      lineHeight: '1.25rem'
    },
    '&__question': {
      fontWeight: 'bold',
      marginBottom: '1rem'
    },
    '&__submit': {
      marginTop: '1.5rem',
      border: '1px solid #000',
      textTransform: 'uppercase',
      backgroundColor: 'transparent',
      padding: '.5rem 1rem',
      cursor: 'pointer',
      transition: '.4s ease-in-out background-color, .4s ease-in-out color',

      '&:hover': {
        backgroundColor: '#000',
        color: '#FFF'
      }
    },
    '&__error': {
      color: '#D0021B',
      margin: '0'
    },
    '&__radio': {
      position: 'relative',
      marginBottom: '.75rem',
      cursor: 'pointer',
      'input': {
        position: 'absolute',
        opacity: '0',
        '&:checked + label:after': {
          opacity: '1'
        }
      },
      'label': {
        paddingLeft: '1.5rem',
        cursor: 'pointer',

        '&:before': {
          content: '""',
          position: 'absolute',
          top: '2px',
          left: 0,
          width: '10px',
          height: '10px',
          border: '2px solid #000',
          borderRadius: '50%'
        },

        '&:after': {
          content: '""',
          position: 'absolute',
          left: '4px',
          top: '6px',
          width: '6px',
          height: '6px',
          backgroundColor: '#000',
          borderRadius: '50%',
          opacity: '0'
        }
      }
    }
  }
})

export const FAQStyle = css({
  '.nav': {
    marginBottom: '4rem',
    justifyContent: 'center',
    '@media (max-width: 767px)': {
      margin: '0 -1.25rem 4rem',
      padding: '0 1.25rem',
      overflow: 'auto',
      flexWrap: 'nowrap',
      justifyContent: 'flex-start'
    },
    'li': {
      margin: '0 0.5rem',
      flexShrink: 0
    },
    'span, button': {
      ...MenuLink,
      color: Colors.mediumGrey,
      padding: '1rem',
      position: 'relative',
      display: 'block',
      cursor: 'pointer',
      background: 'transparent',
      border: 'none',
      transition: 'color 200ms ease',
      '&:after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: 6,
        background: 'black',
        transition: 'all 200ms ease',
        transform: 'scaleX(0)',
        transformOrigin: 'center left',
      },
      '&:hover': {
        color: 'black',
      },
      '&.active': {
        color: 'black',
        '&:after': {
          transform: 'scaleX(1)',
        }
      }
    },
    'button:after': {
      height: 5
    }
  },
  '.accordion': {
    borderBottom: `1px solid ${Colors.extraLightGrey}`,
    '&-item': {
      padding: '1.25rem 0',
      borderTop: `1px solid ${Colors.extraLightGrey}`,
      '&.is-hidden': {
        display: 'none'
      },
      '&.is-open .accordion-title-icon:after': {
        display: 'none'
      }
    },
    '&-title': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 0,
      background: 'transparent',
      border: 'none',
      width: '100%',
      textAlign: 'left',
      fontSize: '1.5rem',
      position: 'relative',
      fontFamily: 'Overpass',
      fontWeight: 200,
      cursor: 'pointer',
      '&-icon': {
        display: 'block',
        position: 'relative',
        flexShrink: 0,
        width: 16,
        height: 16,
        '&:after, &:before': {
          content: "''",
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '100%',
          height: 2,
          background: 'black',
          transformOrigin: 'center',
        },
        '&:after': {
          transform: 'translateX(-50%) translateY(-50%) rotate(-90deg)',
        },
        '&:before': {
          transform: 'translateX(-50%) translateY(-50%)',
        },
      },
    },
    '&-content': {
      maxHeight: 0,
      overflow: 'hidden',
      cursor: 'pointer',
      transition: '.4s max-height ease-in-out',
      '&-inner': {
        margin: 0,
        padding: '22px 85px 35px 0',
        fontSize: '15px',
        fontWeight: 400,
        lineHeight: '25px',
        '@media (max-width: 767px)': {
          paddingRight: '40px'
        },
        'p:first-child': {
          marginTop: 0
        },
        'p:last-child': {
          marginBottom: 0
        }
      }
    }
  }
})

export const FAQBottomStyles = css ({
  paddingTop: '4rem',
  margin: '0 auto',
  textAlign: 'center',
  maxWidth: 445,
  '@media (max-width: 767px)': {
    paddingBottom: '2.5rem'
  },
  'p': {
    fontSize: '18px',
    '@media (max-width: 767px)': {
      fontSize: '15px'
    },
  },
  'button': {
    maxWidth: 248,
    margin: '.75rem 0 0',
    color: '#FFF'
  }
})


// WEBPACK FOOTER //
// ./src/styles/containers/pages.js